
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapid-power-bank/support",
      function () {
        return require("private-next-pages/rapid-power-bank/support/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapid-power-bank/support"])
      });
    }
  